<template>
  <div>
  </div>
</template>
<script>
export default {
  name: "face1",
  props: {
    trainItemExamId: { type: Number },
    businessType: { type: Number },
    examId: { type: Number },
    businessId: { type: Number },
    confirm: { type: Boolean },
    faceType: {type: String},
    isPop:{type:Boolean},
    courseId:{
        type: Number,
        default:null
    },
    taskId:{type:Number},
    courseBeforeAndAfterType:{type:Number},
    nodeId:{type:Number}, // 任务大纲节点id
    resourceId:{type:Number}, // 当前播放资源id
    isfacedialog:{
      type:Boolean,
      default:false,
    },
  },
  data(){
    return{
      isExportImage:false,
      AuthSaveFace:1,
      is_task_courseRule_face_image_export:false,
    }
  },
    created(){
      
        console.log(this.courseId,'this.courseId')
        console.log(this.nodeId,'nodeid');
        console.log(this.courseBeforeAndAfterType,this.taskId,'=========');

    },
    
 async mounted() {
    if(this.courseId){
      await this.getAuthSaveFace()
    }
    const frontendConfigArr = (sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig'))) || this.$store.state.dynamic.frontendConfig || [];
    let is_task_courseRule_face_image_export = frontendConfigArr && frontendConfigArr.filter((item) => {
        if (item.key === 'is_task_courseRule_face_image_export') {
          return true
        }
      })[0];
      console.log(is_task_courseRule_face_image_export,'is_task_courseRule_face_image_export')
    this.is_task_courseRule_face_image_export = is_task_courseRule_face_image_export && is_task_courseRule_face_image_export.value === 'true' ? true : false;
      console.log(this.courseId,'this.courseId')
    var facecount = localStorage.getItem("facecount");
    if(this.confirm){
      this.getAlert()
    }else{
      this.getConfirm()
    }
  },
  methods: {
    // 获取用户授权人脸比对照片保存记录
    async getAuthSaveFace(){
      // 1-已授权，0-未授权
      const params = {
        taskId:this.taskId
      }
      await this.$api.face.getAuthSaveFace({params}).then(res =>{
          if(res.success){
            this.AuthSaveFace = res.data;
          }
      })
    },
      /* eslint-disable */
    changeUrlArg(url, arg, val){
        var pattern = arg+'=([^&]*)';
        var replaceText = arg+'='+val;
        return url.match(pattern) ? url.replace(eval('/('+ arg+'=)([^&]*)/gi'), replaceText) : (url.match('[\?]') ? url+'&'+replaceText : url+'?'+replaceText);
    },
    getAlert() {
      this.$dialog.alert({
          title: "身份验证",
          message:`<div style="white-space:normal;">
              <p style="">请进行人脸识别验证</p>
              <div style="${this.is_task_courseRule_face_image_export && !this.AuthSaveFace ? 'display:block' : 'display:none'} ;margin-top:10px;">
                <input v-model="${this.isExportImage}" onclick='changeCheckbox()' style="position: relative;top: 2px;" type="checkbox">
                <label>确定即表示，同意机构管理员查看、并可以导出确认本人人脸识别照片</label>
              </div>
          </div>`,
          allowHtml:true,
          beforeClose:(action,done)=>{
            if(!this.isExportImage && this.is_task_courseRule_face_image_export && !this.AuthSaveFace && action === 'confirm'){
                this.$toast('请阅读并确认服务约定')
                return done(false)
            }else{
              return done()
            }
          }
      }).then(() => {
          if(this.isExportImage && this.is_task_courseRule_face_image_export){
            const params ={
              taskId:this.taskId
            }
            this.$api.face.authSaveFace({params}).then(res =>{
              console.log(res,'==authSaveFace')
            })
          }
          var faceidentifylocalUrl = '';
          faceidentifylocalUrl = this.courseId ? this.changeUrlArg(window.location.href,'courseId',this.courseId) :window.location.href ;
          console.log(faceidentifylocalUrl,'faceidentifylocalUrl3333')
          if(this.nodeId && !this.$route.query.nodeId){
              faceidentifylocalUrl = `${faceidentifylocalUrl}&nodeId=${this.nodeId}&resourceId=${this.resourceId}`
          }
          if(this.$route.query.nodeId){
            faceidentifylocalUrl = this.changeUrlArg(faceidentifylocalUrl,'nodeId',this.nodeId);
            faceidentifylocalUrl = this.changeUrlArg(faceidentifylocalUrl,'resourceId',this.resourceId);
          }
          console.log(faceidentifylocalUrl,'faceidentifylocalUrl222')
          localStorage.setItem("faceidentifylocalUrl", faceidentifylocalUrl);
          var trainItemExamId = this.trainItemExamId;
          var businessType = this.businessType;
          var examId = this.examId;
          var businessId = this.businessId;
          var faceType = this.faceType;
          let taskId = this.taskId;
          let courseBeforeAndAfterType = this.courseBeforeAndAfterType;//定制山东应急需要
          let resourceId = this.resourceId;
          // window.location.replace(
          //   `${window.location.protocol}//${window.location.host}/faceidentify?trainItemExamId=${trainItemExamId}&businessType=${businessType}&examId=${examId}&isExamFaceRecognize=${isExamFaceRecognize}&businessId=${businessId}`
          // );
          this.$router.push({
               path:'/faceidentify',
               query:{
                 resourceId,
                 trainItemExamId,
                 businessType,
                 examId,
                 businessId,
                 faceType,
                 taskId,
                 courseBeforeAndAfterType,
                 isPop:this.isPop,
                 examDetailQuery:JSON.stringify(this.$route.query)
               }
             })
        })
        .catch(() => {
          this.$emit("close", false);
        });
        window.changeCheckbox = () => {
          this.isExportImage = !this.isExportImage;
          console.log(this.isExportImage,'is===')
        }
    },

    getConfirm() {
      // if(facecount <= 5){
        console.log(this.is_task_courseRule_face_image_export&&!this.AuthSaveFace,this.is_task_courseRule_face_image_export,this.AuthSaveFace,'this.is_task_courseRule_face_image_export && !this.AuthSaveFace')
      this.$dialog
        .confirm({
          title: "身份验证",
          message:`<div style="white-space:normal;">
              <p style="">请进行人脸识别验证</p>
              <div style="${this.is_task_courseRule_face_image_export && !this.AuthSaveFace ? 'display:block' : 'display:none'} ;margin-top:10px;">
                <input v-model="${this.isExportImage}" onclick='changeCheckbox()' style="position: relative;top: 2px;" type="checkbox">
                <label>确定即表示，同意机构管理员查看、并可以导出确认本人人脸识别照片</label>
              </div>
          </div>`,
          allowHtml:true,
          className:'faceconfirm',
          beforeClose:(action,done)=>{
            if(!this.isExportImage && this.is_task_courseRule_face_image_export && !this.AuthSaveFace && action === 'confirm'){
                this.$toast('请阅读并确认服务约定')
                return done(false)
            }else{
              return done()
            }
          }
        })
        .then(() => {
          console.log(this.isExportImage,'this.isExportImage')
          
          if(this.isExportImage && this.is_task_courseRule_face_image_export){
            const params ={
              taskId:this.taskId
            }
            this.$api.face.authSaveFace({params}).then(res =>{
              console.log(res,'==authSaveFace')
            })
          }
          console.log('getConfirm')
          console.log(window.location.href,'window.location.href')
          var faceidentifylocalUrl = '';
          faceidentifylocalUrl = this.courseId ? this.changeUrlArg(window.location.href,'courseId',this.courseId) :window.location.href ;
          if(this.nodeId && !this.$route.query.nodeId){
              faceidentifylocalUrl = `${faceidentifylocalUrl}&nodeId=${this.nodeId}&resourceId=${this.resourceId}`
          }
          if(this.$route.query.nodeId){
            faceidentifylocalUrl = this.changeUrlArg(faceidentifylocalUrl,'nodeId',this.nodeId);
            faceidentifylocalUrl = this.changeUrlArg(faceidentifylocalUrl,'resourceId',this.resourceId);
          }
          faceidentifylocalUrl = faceidentifylocalUrl+'&isFacePage=1'
          localStorage.setItem("faceidentifylocalUrl", faceidentifylocalUrl);
          var trainItemExamId = this.trainItemExamId;
          var businessType = this.businessType;
          var examId = this.examId;
          var businessId = this.businessId;
          var faceType = this.faceType;
          let taskId = this.taskId;
          let resourceId = this.resourceId;
          let courseBeforeAndAfterType = this.courseBeforeAndAfterType;//定制山东应急需要
          // window.location.replace(
          //   `${window.location.protocol}//${window.location.host}/faceidentify?trainItemExamId=${trainItemExamId}&businessType=${businessType}&examId=${examId}&isExamFaceRecognize=${isExamFaceRecognize}&businessId=${businessId}`
          // );
          this.$router.push({
               path:'/faceidentify',
               query:{
                 resourceId,
                 trainItemExamId,
                 businessType,
                 examId,
                 businessId,
                 faceType,
                 taskId,
                 courseBeforeAndAfterType,
                 isPop:this.isPop,
                 examDetailQuery:JSON.stringify(this.$route.query)
               }
             })
        })
        .catch(() => {
          this.$emit("close", false);
        });
      window.changeCheckbox = () => {
        this.isExportImage = !this.isExportImage;
        console.log(this.isExportImage,'is===')
      }
    },
  },
};
</script>
<style lang="less">
  .faceconfirm {
    .van-dialog__footer{
        width:100% !important;
    }
    .van-button--default{
        color: #323233 !important;
        background-color: #fff !important;
        border: 1px solid #ebedf0 !important;
    }
}
</style>
<style scoped lang="less">
.top {
  width: 750px;
  height: 974px;
  background: linear-gradient(143deg, #368dff 0%, #4a66f5 100%);
}

</style>